import ServiceAPI from './ServiceAPI'

export const checkLogin = async (data) => {
  try {
    const response = await ServiceAPI.post('/login/check', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const registerUser = async (data) => {
  try {
    const response = await ServiceAPI.post('/login/register', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getParentDetails = async (lng) => {
  try {
    const response = await ServiceAPI.get(`/parents/details/${lng}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const checkUsername = async (username) => {
  try {
    const response = await ServiceAPI.post('/login/checkforusername', { username })
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const registerParentChild = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/childrens', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getSectionDetails = async (lng) => {
  try {
    const response = await ServiceAPI.get(`/parents/sections/${lng}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getComAnswers = async (id) => {
  try {
    const response = await ServiceAPI.get(`/parents/sectionanswers/${id}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postComAnswers = async (url, body) => {
  try {
    const response = await ServiceAPI.post(`/parents/${url}`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const getFeedbackContent = async (sectionId, selectedCommitments, language) => {
  try {
    const response = await ServiceAPI.get(
      `/parents/sectionfeedbacktext/${sectionId}/${selectedCommitments}/${language}`,
    )
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExeAnswers = async (exercise) => {
  try {
    const response = await ServiceAPI.get(`/parents/${exercise}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseD = async () => {
  try {
    const response = await ServiceAPI.get(`/parents/exerciseD`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getExerciseCData = async () => {
  try {
    const response = await ServiceAPI.get('/parents/exerciseC')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const postExerciseCData = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/exerciseC', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postExerciseDOldData = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/exerciseDold', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const parentFeedback = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/feedback', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const commonFeedback = async (data) => {
  try {
    const response = await ServiceAPI.post('/common/feedback', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postExerciseD = async (data) => {
  try {
    const response = await ServiceAPI.post(`/parents/exerciseD`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const deleteAccount = async () => {
  try {
    const response = await ServiceAPI.delete(`/parents/account`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateAccount = async (data) => {
  try {
    const response = await ServiceAPI.post(`/parents/account`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const changePassword = async (data) => {
  try {
    const response = await ServiceAPI.post(`/parents/changepwd`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const newsletter = async (data) => {
  try {
    const response = await ServiceAPI.post('/common/utpnewsletter', data)
    return response.data
  } catch (error) {
    return error ? error.response : error
  }
}

export const forgotUsernameOrPwd = async (data) => {
  try {
    const response = await ServiceAPI.post(`/login/forgotusernamepwd`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postResetPassword = async (data) => {
  try {
    const response = await ServiceAPI.post(`/login/resetpassword`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const validateresetpasswordtoken = async (data) => {
  try {
    const response = await ServiceAPI.post(`/login/validateresetpasswordtoken`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postSaveWork = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/jurisdiction ', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getSaveWork = async () => {
  try {
    const response = await ServiceAPI.get('/parents/jurisdiction ')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getParentVariables = async (id) => {
  try {
    const response = await ServiceAPI.get(`/parents/variables/${id}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postConfirmComplete = async (data) => {
  try {
    const response = await ServiceAPI.post('/common/confirmcomplete', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postCertificateDetails = async (data) => {
  try {
    const response = await ServiceAPI.post('/parents/certificatedetails', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getCertificateDetails = async () => {
  try {
    const response = await ServiceAPI.get('/parents/certificatedetails')
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getCertificatePdf = async () => {
  try {
    const response = await ServiceAPI.get('/parents/certificate', { responseType: 'blob' })
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postMergeTerm = async (data) => {
  try {
    const response = await ServiceAPI.post(`/parents/mergeterm`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
export const getMergeTerm = async (data) => {
  try {
    const response = await ServiceAPI.get(`/parents/mergeterm`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const postMerge = async (data) => {
  try {
    const response = await ServiceAPI.post(`/parents/merge`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const contentSearch = async (data) => {
  try {
    const response = await ServiceAPI.post(`/common/contentsearch`, data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const getMergeAnswers = async () => {
  try {
    const response = await ServiceAPI.get(`/parents/mergeanswers/0`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const unsubscribe = async (data) => {
  try {
    const response = await ServiceAPI.post('/login/unsubscribe', data)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
